import axios from 'utils/axios';

export const fetchTrials = async (params) => {
    try {
        const response = await axios.get('/trial-deployments', {
            params
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const sendTrialEmail = async (emailData) => {
    const data = {
        id: emailData.id,
        subject: emailData.subject,
        body: emailData.body
    };
    try {
        await axios.post(`/trial-deployments/send-email`, data);
    } catch (e) {
        throw new Error(e.message);
    }
};

export const softDeleteTrial = async (trialId) => {
    try {
        await axios.delete(`/trial-deployments/${trialId}`);
    } catch (e) {
        throw new Error(e.message);
    }
};

export const updateTrial = async (trialId, trialData) => {
    try {
        const response = await axios.put(`/trial-deployments/${trialId}`, trialData);
        return response.data;
    } catch (e) {
        throw new Error(e.response?.data?.message || e.message);
    }
};

export const extendTrial = async (params) => {
    try {
        const response = await axios.put(`/trial-deployments/extend-trial`, params);
        return response.data;
    } catch (e) {
        throw new Error(e.response?.data?.message || e.message);
    }
};
